import { z } from "zod"
import { USAGE_DAYS, USAGE_PERIODS } from "@/lib/constants"

export const ETS_TABS = [
	"usage",
	"users",
	"voyage-actions",
	"registries",
] as const

export type EtsTab = (typeof ETS_TABS)[number]

export const etsSearchSchema = z.object({
	tab: z.enum(ETS_TABS).optional().catch(undefined),
	accountId: z.number().optional().catch(undefined),
	days: z
		.literal([...USAGE_PERIODS])
		.default(USAGE_DAYS)
		.catch(USAGE_DAYS),
})
